/* Noon Style theme — global.js */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const theme = window.theme || { routes: {}, strings: {} };

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    format = format || theme.moneyFormat || '{{amount}}';
    const value = (cents / 100).toFixed(2);
    const [whole, dec] = value.split('.');
    const withDelim = (w, sep) => w.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    let out;
    if (format.includes('amount_no_decimals_with_comma_separator')) out = withDelim(whole, '.');
    else if (format.includes('amount_no_decimals')) out = withDelim(whole, ',');
    else if (format.includes('amount_with_comma_separator')) out = withDelim(whole, '.') + ',' + dec;
    else out = withDelim(whole, ',') + '.' + dec;
    return format.replace(/\{\{\s*amount[^}]*\}\}/, out);
  }

  function toast(msg, link) {
    const el = $('#Toast');
    if (!el) return;
    el.innerHTML = msg + (link ? ` <a href="${link.href}">${link.text}</a>` : '');
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(el._t);
    el._t = setTimeout(() => { el.classList.remove('is-visible'); setTimeout(() => (el.hidden = true), 300); }, 3200);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((b) => { b.textContent = count; b.dataset.count = count; });
  }

  async function fetchJSON(url, opts) {
    const r = await fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts));
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw data;
    return data;
  }

  async function addToCart(id, quantity = 1, properties) {
    const body = { items: [{ id, quantity, properties }] };
    await fetchJSON(theme.routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify(body) });
    const cart = await fetchJSON(theme.routes.cart + '.js');
    updateCartCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    return cart;
  }

  /* ---------- drawers (DAR-006: keyboard + screen-reader friendly dialogs) ---------- */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const focusables = (root) => $$(FOCUSABLE, root).filter((el) => el.offsetParent !== null || el === document.activeElement);
  function openDrawer(id, opener) {
    const d = document.getElementById(id);
    if (!d) return;
    d._opener = opener || document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (!d.hasAttribute('role')) d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    $$('[data-drawer-open="' + id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('no-scroll');
    const panel = $('.drawer__panel', d) || d;
    const first = $('.drawer__close, [data-drawer-close]', panel) || focusables(panel)[0] || panel;
    if (first === panel) panel.setAttribute('tabindex', '-1');
    setTimeout(() => first.focus({ preventScroll: true }), 30);
  }
  function closeDrawer(d) {
    if (!d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$('[data-drawer-open="' + d.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
    const back = d._opener;
    d._opener = null;
    if (back && typeof back.focus === 'function' && document.contains(back)) back.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen, opener); return; }
    const closer = e.target.closest('[data-drawer-close], .drawer__overlay');
    if (closer) { const d = closer.closest('.drawer'); if (d) closeDrawer(d); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { $$('.drawer.is-open').forEach(closeDrawer); return; }
    if (e.key !== 'Tab') return;
    const open = $$('.drawer.is-open');
    const d = open[open.length - 1];
    if (!d) return;
    const panel = $('.drawer__panel', d) || d;
    const list = focusables(panel);
    if (!list.length) { e.preventDefault(); panel.focus(); return; }
    const first = list[0], last = list[list.length - 1];
    const inside = panel.contains(document.activeElement);
    if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
  });
  $$('[data-drawer-open]').forEach((b) => { b.setAttribute('aria-expanded', 'false'); if (!b.hasAttribute('aria-haspopup')) b.setAttribute('aria-haspopup', 'dialog'); });

  // mobile menu accordions
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    e.preventDefault();
    const open = t.closest('.menu-list__item').classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- product image lightbox (DAR-028) ---------- */
  (function () {
    const box = $('#ProductLightbox');
    if (!box) return;
    const imgs = $$('[data-lightbox-index]', box);
    const count = $('[data-lightbox-count]', box);
    let idx = 0, opener = null;
    function show(i) {
      if (!imgs.length) return;
      idx = ((i % imgs.length) + imgs.length) % imgs.length;
      imgs.forEach((im, n) => { im.hidden = n !== idx; });
      if (count) count.textContent = (idx + 1) + ' / ' + imgs.length;
    }
    function open(i) {
      opener = document.activeElement;
      box.hidden = false;
      box.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      show(i);
      const close = $('.lightbox__close', box);
      setTimeout(() => close && close.focus(), 20);
    }
    function close() {
      box.hidden = true;
      box.setAttribute('aria-hidden', 'true');
      if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
      if (opener && document.contains(opener)) opener.focus();
    }
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-lightbox-open]')) {
        e.preventDefault();
        const gallery = $('.gallery[data-carousel]');
        const current = gallery ? parseInt(gallery.dataset.index || '0', 10) : 0;
        const slide = gallery ? $$('.gallery__slide', gallery)[current] : null;
        const mediaId = slide && slide.dataset.mediaId;
        const target = imgs.findIndex((im) => im.dataset.mediaId === mediaId);
        open(target > -1 ? target : 0);
        return;
      }
      if (e.target.closest('.gallery__slide img') && !e.target.closest('a')) {
        const trigger = $('[data-lightbox-open]');
        if (trigger) { e.preventDefault(); trigger.click(); }
        return;
      }
      if (e.target.closest('[data-lightbox-close]')) { close(); return; }
      if (e.target.closest('[data-lightbox-prev]')) { show(idx - 1); return; }
      if (e.target.closest('[data-lightbox-next]')) { show(idx + 1); }
    });
    document.addEventListener('keydown', (e) => {
      if (box.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'Tab') {
        const list = $$('button:not([disabled])', box).filter((b) => b.offsetParent !== null);
        if (!list.length) return;
        const first = list[0], last = list[list.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  })();

  /* ---------- carousels ---------- */
  function initCarousel(root) {
    const track = $('.carousel__track, .hero__track, .gallery__track', root);
    if (!track) return;
    const prev = $('[data-prev]', root);
    const next = $('[data-next]', root);
    const dots = $$('[data-dot]', root);
    const thumbs = $$('[data-thumb]', root);
    const items = Array.from(track.children);
    const gapOf = () => { const g = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap); return isNaN(g) ? 0 : g; };
    const step = () => (items[0] ? items[0].getBoundingClientRect().width + gapOf() : track.clientWidth);
    const fullWidth = () => items[0] && items[0].getBoundingClientRect().width >= track.clientWidth * 0.9;

    function update() {
      const max = track.scrollWidth - track.clientWidth - 2;
      const loop = fullWidth() && items.length > 1;
      if (prev) prev.disabled = !loop && track.scrollLeft <= 2;
      if (next) next.disabled = !loop && track.scrollLeft >= max;
      const idx = Math.round(track.scrollLeft / step());
      dots.forEach((d, i) => { d.classList.toggle('is-active', i === idx); if (d.hasAttribute('role')) d.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      root.dataset.index = idx;
    }
    const goTo = (i) => { const n = items.length; if (!n) return; i = ((i % n) + n) % n; track.scrollTo({ left: i * step(), behavior: 'smooth' }); };
    const current = () => Math.round(track.scrollLeft / step());
    prev && prev.addEventListener('click', () => { if (fullWidth()) goTo(current() - 1); else track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' }); });
    next && next.addEventListener('click', () => { if (fullWidth()) goTo(current() + 1); else track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' }); });
    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    root.goTo = goTo;
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();

    // autoplay (hero) — DAR-010: persistent pause/play, pause on focus, honour prefers-reduced-motion
    const auto = parseInt(root.dataset.autoplay || '0', 10);
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const toggle = $('[data-autoplay-toggle]', root);
    if (auto > 0 && items.length > 1 && !reduced) {
      let timer, userPaused = false;
      const start = () => { clearInterval(timer); if (userPaused) return; timer = setInterval(() => { if (document.hidden || root.matches(':hover, :focus-within')) return; goTo(current() + 1); }, auto * 1000); };
      const stop = () => clearInterval(timer);
      const setToggle = () => {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        toggle.classList.toggle('is-paused', userPaused);
        toggle.setAttribute('aria-label', userPaused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
      };
      start();
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start, { passive: true });
      toggle && toggle.addEventListener('click', () => { userPaused = !userPaused; setToggle(); if (userPaused) stop(); else start(); });
      setToggle();
    } else if (toggle) {
      toggle.hidden = true;
    }
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- wishlist (localStorage) ---------- */
  const WL_KEY = 'noon_wishlist';
  const getWL = () => { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } };
  const setWL = (arr) => { try { localStorage.setItem(WL_KEY, JSON.stringify(arr)); } catch (e) {} ; $$('[data-wishlist-count]').forEach((b) => { b.textContent = arr.length; b.dataset.count = arr.length; }); };
  function syncWishlistButtons() {
    const wl = getWL();
    $$('[data-wishlist]').forEach((b) => {
      const on = wl.includes(b.dataset.wishlist);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      const title = b.dataset.title;
      if (title && theme.strings.wishlistAdd) b.setAttribute('aria-label', (on ? theme.strings.wishlistRemove || theme.strings.wishlistAdd : theme.strings.wishlistAdd) + ': ' + title);
    });
    $$('[data-wishlist-count]').forEach((b) => { b.textContent = wl.length; b.dataset.count = wl.length; });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    const handle = b.dataset.wishlist;
    let wl = getWL();
    const removing = wl.includes(handle);
    if (removing) wl = wl.filter((h) => h !== handle); else wl.push(handle);
    setWL(wl);
    syncWishlistButtons();
    // DAR-019: on the wishlist page, drop the card at once and show the empty state when nothing is left
    const page = b.closest('[data-wishlist-page]');
    if (removing && page) {
      const card = b.closest('.product-card');
      const grid = $('[data-wishlist-grid]', page);
      if (card) card.remove();
      if (grid && !grid.children.length) { const empty = $('[data-wishlist-empty]', page); if (empty) empty.hidden = false; }
      toast(theme.strings.removedFromWishlist || theme.strings.wishlistRemove || 'Removed');
    }
  });
  syncWishlistButtons();

  // JS product card (used by wishlist page and cart recommendations)
  const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  function cardHTML(p) {
    const v = p.variants[0];
    const wl = getWL();
    const off = p.compare_at_price > p.price ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
    const s = theme.strings;
    const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_400x$1$2') : '';
    const offText = (s.offTemplate || 'PCT% Off').replace('PCT', off);
    const isGlobal = (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).map((t) => String(t).trim()).includes('DarMall Global') || p.vendor === 'DarMall Global';
    const express = theme.express && theme.express.enabled && !isGlobal ? `<div class="product-card__express"><span class="express-badge"><span class="express-badge__brand">${esc(theme.express.label)}</span><span class="express-badge__when">${esc(theme.express.days)}</span></span></div>` : (isGlobal && s.globalDays ? `<div class="product-card__delivery text-muted">${esc(s.globalDays)}</div>` : '');
    return `
      <div class="product-card">
        <div class="product-card__media">
          ${img ? `<img src="${img}" alt="${esc(p.title)}" loading="lazy" width="400" height="400">` : ''}
          <button type="button" class="product-card__wishlist${wl.includes(p.handle) ? ' is-active' : ''}" data-wishlist="${esc(p.handle)}" data-title="${esc(p.title)}" aria-pressed="${wl.includes(p.handle) ? 'true' : 'false'}" aria-label="${esc((wl.includes(p.handle) ? s.wishlistRemove || s.wishlistAdd : s.wishlistAdd) || 'Wishlist')}: ${esc(p.title)}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.3 4.5 6.8 4.5c2 0 3.5 1.1 5.2 3 1.7-1.9 3.2-3 5.2-3 3.5 0 5.4 3.5 4.1 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>
          </button>
          ${v && v.available ? (p.variants.length === 1 ? `<button type="button" class="product-card__quick-add" data-quick-add="${v.id}" aria-label="${esc((s.quickAddTemplate || 'Add TITLE to cart').replace('TITLE', p.title))}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button>` : `<a href="${p.url}" class="product-card__quick-add" style="z-index:2" aria-label="${esc(s.chooseOptions || 'Choose options')}: ${esc(p.title)}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></a>`) : ''}
        </div>
        ${off ? `<div class="product-card__deal"><span>${esc(s.deal || 'Deal')}</span><span class="product-card__deal-pct">-${off}%</span></div>` : ''}
        <div class="product-card__body">
          <h3 class="product-card__title"><a href="${p.url}">${esc(p.title)}</a></h3>
          <div class="price"><span class="price__current">${formatMoney(p.price)}</span>${off ? `<s class="price__compare">${formatMoney(p.compare_at_price)}</s><span class="price__off">${esc(offText)}</span>` : ''}</div>
          ${s.freeDelivery ? `<div class="product-card__delivery"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h11v10H2zM13 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg> ${esc(s.freeDelivery)}</div>` : ''}
          ${express}
        </div>
      </div>`;
  }

  // wishlist page renderer (products via /products/handle.js)
  const wlPage = $('[data-wishlist-page]');
  if (wlPage) {
    const wl = getWL();
    const empty = $('[data-wishlist-empty]', wlPage);
    const grid = $('[data-wishlist-grid]', wlPage);
    if (!wl.length) { if (empty) empty.hidden = false; }
    else {
      Promise.all(wl.map((h) => fetch(`${theme.routes.root}products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null))).then((ps) => {
        ps.filter((p) => p && p.available).forEach((p) => grid.insertAdjacentHTML('beforeend', cardHTML(p)));
        if (!grid.children.length && empty) empty.hidden = false;
      });
    }
  }

  // cart recommendations: Shopify recommendations for the first cart item, only cheaper products
  $$('[data-cart-reco]').forEach((box) => {
    const pid = box.dataset.productId, max = parseInt(box.dataset.maxPrice || '0', 10), limit = box.dataset.limit || 10;
    const track = $('[data-cart-reco-track]', box);
    if (!pid || !track) return;
    fetch(`${theme.routes.root}recommendations/products.json?product_id=${pid}&limit=${limit}&intent=related`)
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then((d) => {
        const ps = (d.products || []).filter((p) => p.available && (!max || p.price < max));
        if (!ps.length) return;
        track.innerHTML = ps.map((p) => `<div class="carousel__item carousel__item--product">${cardHTML(p)}</div>`).join('');
        box.hidden = false;
        const root = $('[data-carousel]', box);
        if (root) initCarousel(root);
      })
      .catch(() => {});
  });

  /* ---------- country dropdown ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.country-dd__btn');
    if (btn) {
      e.preventDefault();
      const dd = btn.closest('[data-country-dd]');
      const menu = $('.country-dd__menu', dd);
      const open = !menu.hidden;
      $$('.country-dd__menu').forEach((m) => (m.hidden = true));
      menu.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
      return;
    }
    const opt = e.target.closest('[data-country]');
    if (opt) {
      e.preventDefault();
      const form = opt.closest('form');
      const input = form && form.querySelector('input[name="country_code"]');
      if (input) { input.value = opt.dataset.country; form.submit(); }
      return;
    }
    if (!e.target.closest('[data-country-dd]')) $$('.country-dd__menu').forEach((m) => (m.hidden = true));
  });

  /* ---------- quick add ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    try {
      await addToCart(parseInt(b.dataset.quickAdd, 10), 1);
      toast(theme.strings.added, { href: theme.routes.cart, text: theme.strings.cartLink || 'Cart' });
    } catch (err) {
      toast((err && err.description) || theme.strings.cartError);
    } finally { b.classList.remove('is-loading'); }
  });

  /* ---------- predictive search ---------- */
  $$('[data-predictive]').forEach((form) => {
    const input = $('input[type="search"]', form);
    const results = $('.predictive-search', form);
    const clear = $('.search-form__clear', form);
    if (!input || !results) return;
    let t, last = '';
    const close = () => { results.hidden = true; };
    const toggleClear = () => form.classList.toggle('has-value', input.value.length > 0);
    input.addEventListener('input', () => {
      toggleClear();
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      t = setTimeout(async () => {
        if (q === last) return; last = q;
        try {
          const r = await fetch(`${theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`);
          const html = await r.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('#shopify-section-predictive-search');
          results.innerHTML = inner ? inner.innerHTML : '';
          results.hidden = !results.innerHTML.trim();
        } catch (err) { close(); }
      }, 250);
    });
    input.addEventListener('focus', () => { if (results.innerHTML.trim() && input.value.trim().length >= 2) results.hidden = false; });
    clear && clear.addEventListener('click', () => { input.value = ''; toggleClear(); close(); input.focus(); });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
    toggleClear();
  });

  /* ---------- sticky search placeholder rotation ---------- */
  $$('[data-placeholder-list]').forEach((input) => {
    const list = input.dataset.placeholderList.split('|').map((s) => s.trim()).filter(Boolean);
    if (list.length < 2) return;
    let i = 0;
    setInterval(() => { if (document.activeElement !== input && !input.value) { i = (i + 1) % list.length; input.placeholder = list[i]; } }, 3500);
  });

  /* ---------- product form ---------- */
  $$('[data-product-form]').forEach((root) => {
    const product = JSON.parse($('[data-product-json]', root).textContent);
    const form = $('form[data-type="add-to-cart-form"]', root);
    const idInput = $('input[name="id"]', form);
    const qtyInput = $('input[name="quantity"]', root);
    const addBtns = $$('[data-add-to-cart]', root);
    const buyNowBtns = $$('[data-buy-now]', root);
    const priceEls = $$('[data-product-price]', root);
    const stockEl = $('[data-stock]', root);
    const skuEl = $('[data-sku]', root);
    const gallery = $('[data-carousel]', root);
    const lowStock = parseInt(root.dataset.lowStock || '5', 10);
    const invMap = (() => { try { return JSON.parse($('[data-inventory-json]', root).textContent); } catch (e) { return {}; } })();

    function selectedOptions() {
      return $$('fieldset[data-option]', root).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      if (!opts.length) {
        const id = parseInt(idInput.value, 10);
        return product.variants.find((v) => v.id === id) || product.variants[0];
      }
      return product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }
    function renderPrice(v) {
      const pct = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
      priceEls.forEach((el) => {
        el.innerHTML = `<span class="price__current">${formatMoney(v.price)}</span>` +
          (pct ? `<s class="price__compare">${formatMoney(v.compare_at_price)}</s><span class="price__off">${(el.dataset.offTemplate || 'PCT% Off').replace('PCT', pct)}</span>` : '');
      });
    }
    function updateAvailability(opts) {
      $$('fieldset[data-option]', root).forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const v = product.variants.find((pv) => pv.options.every((o, i) => i === idx ? o === inp.value : (opts[i] == null || o === opts[i])));
          const label = inp.nextElementSibling;
          label && label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      const opts = selectedOptions();
      const v = findVariant(opts);
      updateAvailability(opts);
      if (!v) {
        addBtns.forEach((b) => { b.disabled = true; b.querySelector('span').textContent = theme.strings.unavailable; });
        return;
      }
      idInput.value = v.id;
      renderPrice(v);
      if (skuEl) skuEl.textContent = v.sku || '';
      addBtns.forEach((b) => { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut; });
      buyNowBtns.forEach((b) => { b.disabled = !v.available; });
      if (stockEl) {
        const qty = invMap[v.id];
        if (!v.available) { stockEl.textContent = stockEl.dataset.outText; stockEl.className = 'buy-box__stock buy-box__stock--low'; }
        else if (typeof qty === 'number' && qty > 0 && qty <= lowStock) { stockEl.textContent = stockEl.dataset.lowText.replace('COUNT', qty); stockEl.className = 'buy-box__stock buy-box__stock--low'; }
        else { stockEl.textContent = stockEl.dataset.inText; stockEl.className = 'buy-box__stock'; }
      }
      // gallery jump
      if (gallery && v.featured_media) {
        const idx = $$('.gallery__slide', gallery).findIndex((s) => s.dataset.mediaId == v.featured_media.id);
        if (idx > -1 && gallery.goTo) gallery.goTo(idx);
      }
      // url
      if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      $$('[data-selected-value]', root).forEach((el) => { const i = parseInt(el.dataset.selectedValue, 10); el.textContent = opts[i] || ''; });
    }
    root.addEventListener('change', (e) => { if (e.target.closest('fieldset[data-option]')) update(); });

    // qty
    $$('[data-qty-minus], [data-qty-plus]', root).forEach((b) => b.addEventListener('click', () => {
      const n = parseInt(qtyInput.value || '1', 10) + (b.hasAttribute('data-qty-plus') ? 1 : -1);
      qtyInput.value = Math.max(1, n);
      qtyInput.dispatchEvent(new Event('change'));
    }));
    qtyInput && qtyInput.addEventListener('change', () => { $$('input[name="quantity"]', root).forEach((i) => (i.value = qtyInput.value)); });

    // add to cart
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = e.submitter || addBtns[0];
      addBtns.forEach((b) => b.classList.add('btn--loading'));
      try {
        await addToCart(parseInt(idInput.value, 10), parseInt(qtyInput ? qtyInput.value : 1, 10));
        toast(theme.strings.added, { href: theme.routes.cart, text: theme.strings.cartLink || 'Cart' });
      } catch (err) { toast((err && err.description) || theme.strings.cartError); }
      finally { addBtns.forEach((b) => b.classList.remove('btn--loading')); }
    });
    addBtns.forEach((b) => { if (b.form !== form) b.addEventListener('click', (e) => { e.preventDefault(); form.requestSubmit(); }); });
    buyNowBtns.forEach((b) => b.addEventListener('click', async (e) => {
      e.preventDefault();
      b.classList.add('btn--loading');
      try { await addToCart(parseInt(idInput.value, 10), parseInt(qtyInput ? qtyInput.value : 1, 10)); location.href = theme.routes.root.replace(/\/$/, '') + '/checkout'; }
      catch (err) { toast((err && err.description) || theme.strings.cartError); b.classList.remove('btn--loading'); }
    }));
    update();
  });

  /* ---------- cart page ---------- */
  const cartRoot = $('[data-cart]');
  if (cartRoot) {
    const sectionId = cartRoot.dataset.sectionId;
    async function change(line, quantity) {
      const item = $(`[data-line="${line}"]`, cartRoot);
      item && item.classList.add('is-loading');
      try {
        const r = await fetch(theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity, sections: sectionId }) });
        const data = await r.json();
        if (!r.ok) throw data;
        const html = data.sections && data.sections[sectionId];
        if (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-cart]');
          if (fresh) cartRoot.innerHTML = fresh.innerHTML;
        }
        updateCartCount(data.item_count);
      } catch (err) { toast((err && err.description) || theme.strings.cartError); item && item.classList.remove('is-loading'); }
    }
    cartRoot.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-remove]');
      if (rm) { e.preventDefault(); change(parseInt(rm.dataset.remove, 10), 0); return; }
      const minus = e.target.closest('[data-line-minus]');
      const plus = e.target.closest('[data-line-plus]');
      if (minus || plus) {
        const b = minus || plus;
        const input = $(`input[data-line-qty="${b.dataset.lineMinus || b.dataset.linePlus}"]`, cartRoot);
        const n = parseInt(input.value, 10) + (plus ? 1 : -1);
        change(parseInt(input.dataset.lineQty, 10), Math.max(0, n));
      }
      const wl = e.target.closest('[data-move-wishlist]');
      if (wl) {
        e.preventDefault();
        let list = getWL(); if (!list.includes(wl.dataset.moveWishlist)) list.push(wl.dataset.moveWishlist); setWL(list);
        change(parseInt(wl.dataset.line, 10), 0);
        toast(theme.strings.movedToWishlist || 'Moved to wishlist', { href: theme.wishlistUrl || '/pages/wishlist', text: theme.strings.wishlistLink || 'Wishlist' });
      }
    });
    cartRoot.addEventListener('change', (e) => {
      const input = e.target.closest('input[data-line-qty]');
      if (input) change(parseInt(input.dataset.lineQty, 10), Math.max(0, parseInt(input.value || '0', 10)));
      const note = e.target.closest('[name="note"]');
      if (note) fetch(theme.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    });
  }

  /* ---------- collection: facets auto submit, sort, view toggle ---------- */
  $$('[data-facets-form]').forEach((form) => {
    let t;
    form.addEventListener('change', (e) => {
      if (e.target.closest('[data-no-auto]')) return;
      clearTimeout(t); t = setTimeout(() => form.requestSubmit ? form.requestSubmit() : form.submit(), 300);
    });
  });
  $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
  }));
  $$('[data-view]').forEach((b) => b.addEventListener('click', () => {
    const grid = $('[data-product-grid]');
    if (!grid) return;
    grid.classList.toggle('product-grid--list', b.dataset.view === 'list');
    $$('[data-view]').forEach((x) => { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    try { localStorage.setItem('noon_view', b.dataset.view); } catch (e) {}
  }));
  try { const v = localStorage.getItem('noon_view'); if (v) { const b = $(`[data-view="${v}"]`); b && b.click(); } } catch (e) {}

  /* ---------- countdown ---------- */
  $$('[data-countdown]').forEach((el) => {
    const end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let d = Math.max(0, end - Date.now());
      const h = Math.floor(d / 36e5); d -= h * 36e5;
      const m = Math.floor(d / 6e4); d -= m * 6e4;
      const s = Math.floor(d / 1e3);
      el.textContent = `${pad(h)} : ${pad(m)} : ${pad(s)}`;
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- copy ---------- */
  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-copy]');
    if (!c) return;
    navigator.clipboard && navigator.clipboard.writeText(c.dataset.copy).then(() => toast(c.dataset.copiedText || 'Copied!'));
  });

  /* ---------- active bottom nav ---------- */
  $$('.bottom-nav__item[href]').forEach((a) => {
    const p = a.getAttribute('href');
    if (p && p !== '/' && location.pathname.startsWith(p)) a.classList.add('is-active');
    if (p === theme.routes.root && location.pathname === theme.routes.root) a.classList.add('is-active');
  });

  window.themeUtils = { addToCart, toast, formatMoney, openDrawer, initCarousel };
})();
